module.exports = [{"name":"HERO","layout":"CONTENT_LEFT","hasCTA":false,"assetName":"bravenet_siteblocks_welcome","assetType":"png"}]


//////////////////
// WEBPACK FOOTER
// ./apps/www.bravenet.com/src/assets/data/sitebuilder/templates/panels.json
// module id = cEu5
// module chunks = 0